import React, { FC } from 'react';
import { useSelector } from 'react-redux';

import { WebSearchIcon } from 'src/shared/components/icons';
import { getCurrentCulture } from 'src/store/localizations/localizations.selectors';

/*
    Notes : Edge cases when the translations api would fail, the following strings are stored at this level.
    If the user's language preference cannot be retrieved as well, then the language is determine using the browser's
    default language.
 */
export const MobileResolutionPage: FC = () => {
  const currentCulture = useSelector(getCurrentCulture);
  const { title, message } = getLocalizedStrings(currentCulture);

  return (
    <div className="h-100 w-100 d-flex align-items-center justify-content-center flex-column">
      <WebSearchIcon />
      <div className="px-4 mt-5 text-center">
        <h1 className="h4 fw-medium">{title}</h1>
        <p className="text-muted my-3">{message}</p>
      </div>
    </div>
  );
};

const getLocalizedStrings = (culture: string): { title: string; message: string } => {
  switch (culture.substring(0, 2).toLowerCase()) {
    case 'fr':
      return {
        message: "Cette page s'affiche mieux sur votre ordinateur.",
        title: "Cette page n'est disponible que sur ordinateur!",
      };
    case 'es':
    case 'en':
    default:
      return {
        message: 'This page is best viewed on your computer.',
        title: 'This page is only available on desktop!',
      };
  }
};
